export default __webpack_public_path__ + "static/media/doorman.e88c4ed8.svg";